import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../shared/state/root-reducer';
import { AppDispatch } from '../../shared/state/store';

function AuthenticationMonitor() {
    const navigate = useNavigate();

    const userContext = useSelector(
        (state: RootState) => state.userContext
    );

    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
      if (userContext.userIsAuthenticated) {
          if (userContext.homeRoute && userContext.homeRoute.length > 0) {
            if (window.location.pathname === "" || window.location.pathname === "/"
           ) {
                navigate(userContext.homeRoute);
            }
          }
       }
    }, [navigate, userContext.userIsAuthenticated, userContext.homeRoute, userContext.onLoginScreen, dispatch]);

    return (
        <div></div>
    )
}

export default AuthenticationMonitor;
